// src/store/modules/liquidation/actions.js
import LiquidationApi from "../../../api/modules/LiquidationApi";

export const sendLiquidationToOdoo = async ({commit}, payload) => {
  try {
    const {context, idLiquidation} = payload;
    const response = await LiquidationApi.sendLiquidationToOdoo(context, {idLiquidation});
    return response;
  } catch (error) {
    console.error("Error al enviar la liquidación a Odoo:", error);
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/liquidation/actions.js